import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',

        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiInputBase-root': {
            fontSize: theme.typography.size.m,
        },
    },
    dropDownOption: {
        fontSize: theme.typography.size.m,
    },
}));
